export default __webpack_public_path__ + "static/media/Archia-Regular.0a649844.otf";